import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const lines = ["Shape the narrative.", "Protect the", "reputation."];

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.3 + i * 0.15 },
  }),
};

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.55, 0.85]);

  return (
    <section
      ref={ref}
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen grain overflow-hidden bg-navy text-ivory flex items-end"
    >
      <motion.div className="absolute inset-0" style={{ y: imgY }}>
        <img
          src="https://images.unsplash.com/photo-1764810815228-b7f9432eec5c?crop=entropy&cs=srgb&fm=jpg&q=80&w=2000"
          alt="Executive boardroom where strategic communications work happens"
          className="h-[120%] w-full object-cover"
          loading="eager"
        />
        <motion.div className="absolute inset-0 bg-navy" style={{ opacity: overlayOpacity }} />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-7xl w-full px-6 pb-24 pt-40">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="overline text-gold mb-8"
        >
          Strategic Communications &amp; Crisis Management
        </motion.p>

        <h1 className="font-serif font-light tracking-tight leading-[1.02] text-5xl sm:text-7xl lg:text-8xl max-w-5xl">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariants} initial="hidden" animate="visible" className="block">
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.9 }}
          className="mt-12 flex flex-col sm:flex-row sm:items-end gap-8 sm:gap-16"
        >
          <p className="text-ivory/75 text-base sm:text-lg max-w-md leading-relaxed">
            Park Communications advises executives, legal teams and institutions when reputation, narrative and
            outcome are on the line.
          </p>
          <a
            href="#contact"
            data-testid="hero-cta"
            className="shrink-0 group inline-flex items-center gap-3 text-navy bg-gold hover:bg-ivory transition-colors px-8 py-4 overline"
          >
            Start a conversation
            <span className="transition-transform group-hover:translate-x-1">&rarr;</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
